module.exports = __webpack_public_path__ + "static/img/image_solutions_accss_01.31e878d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_accss_01.png
// module id = FktC
// module chunks = 10